import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Instagram, Twitter } from "lucide-react";
import { http } from "../lib/api";
import Marquee from "./Marquee";

export default function Footer() {
  const [footer, setFooter] = useState(null);
  const [email, setEmail] = useState("");

  useEffect(() => { http.get("/footer").then((r) => setFooter(r.data)).catch(() => {}); }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await http.post("/newsletter", { email, source: "footer" });
      toast.success("You're on the list.");
      setEmail("");
    } catch { toast.error("Could not subscribe"); }
  };

  return (
    <footer className="bg-[#070708] border-t border-zinc-900 mt-16">
      <Marquee placement="above_footer" />
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <span className="font-display text-4xl tracking-widest text-white">STREETSINS</span>
          <p className="text-sm text-zinc-500 mt-4 max-w-xs leading-relaxed">{footer?.blurb}</p>
          <div className="flex gap-3 mt-5">
            {footer?.social?.instagram && <a href={footer.social.instagram} target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-accent" aria-label="Instagram"><Instagram size={18} /></a>}
            {footer?.social?.twitter && <a href={footer.social.twitter} target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-accent" aria-label="Twitter"><Twitter size={18} /></a>}
          </div>
        </div>
        {(footer?.columns || []).map((col) => (
          <div key={col.title}>
            <p className="text-[11px] uppercase tracking-widest text-zinc-300 font-semibold mb-4">{col.title}</p>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}><Link to={l.link} className="text-sm text-zinc-500 hover:text-white transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-zinc-900">
        <form onSubmit={subscribe} className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col sm:flex-row items-center gap-3">
          <p className="text-xs uppercase tracking-widest text-zinc-400 sm:mr-auto">Join the newsletter</p>
          <div className="flex w-full sm:w-auto">
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              placeholder="your@email.com" data-testid="footer-newsletter-input"
              className="bg-zinc-900 border border-zinc-800 px-4 py-2.5 text-sm w-full sm:w-64 focus:border-accent-ss" />
            <button className="btn-accent px-5 text-xs font-bold uppercase tracking-wider" data-testid="footer-newsletter-submit">Join</button>
          </div>
        </form>
      </div>
      <div className="border-t border-zinc-900 py-5 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} StreetSins. All rights reserved. Prices incl. GST.
      </div>
    </footer>
  );
}
